import bindAll from 'lodash.bindall';
import React from 'react';
import PropTypes from 'prop-types';
import { connect, Provider } from 'react-redux';
import { createStore, combineReducers, compose } from 'redux';
import { IntlProvider } from 'react-intl';
import { setUser } from './reducers/teach'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';


import HomePage from './pages/home/home';
import CoursesPage from "./pages/courses/courses";
import CoursePage from "./pages/course/course";
import WrappedGui from './components/wrapped-gui/wrapped-gui.jsx';
import AppStateHOC from "../lib/app-state-hoc";
import LessonPage from "./pages/lesson/lesson";
import TeacherClazzPage from "./pages/teacher-clazz/teacher-clazz";
import TeacherClazzesPage from "./pages/teacher-clazzes/teacher-clazzes";
import TeacherCoursesPage from "./pages/teacher-courses/teacher-courses";
import TeacherCoursePage from "./pages/teacher-course/teacher-course";
import MinePage from "./pages/mine/mine";
import SetitingPage from "./pages/accounts/settings";
import PromotePage from "./pages/accounts/promote";
import StatisticsPage from "./pages/accounts/statistics/statistics";
import {closeLoginMenu, loginMenuOpen} from "../reducers/menus";
import ProjectsPage from "./pages/projects/projects";
import TestPage from "./pages/test/test";
import TeacherPage from "./pages/teacher/teacher";
import UserProfilePage from "./pages/user-profile/UserProfilePage";
import MyClasses from "./pages/my-classes/my-classes";
import MyClazzPage from "./pages/my-clazz/my-clazz";
import MyCoursePage from "./pages/my-course/my-course";
import HelperCenter from './pages/helper-center/helper';
import Competition from "./pages/competition/index";
import VipPage from "./pages/vip/index";
import TeacherIndex from "./pages/teacher-index/teacher-index";


class NavRouter extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    // async componentDidMount() {
    //     let user = await me();
    //     this.props.setUser(user);
    // }

    render() {
        return (
            /*
            <Provider store={this.store}>
                <IntlProvider>

             */
            <Router>
                <Switch>
                    <Route
                        path={[`${window.config.appPath}/`, `${window.config.appPath}/index`, `${window.config.appPath}/home`]}
                        exact={true}
                        component={HomePage}
                    />
                    <Route
                        path={`${window.config.appPath}/courses/:filter`}
                        component={CoursesPage}
                    />
                    <Route
                        path={`${window.config.appPath}/course`}
                        render={props => (<CoursePage {...props} key={props.location.search} />)}
                    />
                    <Route
                        path={`${window.config.appPath}/lesson`}
                        render={props => (<LessonPage {...props} key={props.location.search} />)}
                    />

                    <Route
                        path={`${window.config.appPath}/teacher`}
                        exact={true}
                        component={TeacherPage}
                    />
                    <Route
                        path={`${window.config.appPath}/teacher/courses`}
                        component={TeacherCoursesPage}
                    />
                    <Route
                        path={`${window.config.appPath}/teacher/course`}
                        render={props => (<TeacherCoursePage {...props} key={props.location.search} />)}
                    />
                    <Route
                        path={`${window.config.appPath}/teacher/classes`}
                        component={TeacherClazzesPage}
                    />
                    <Route
                        path={`${window.config.appPath}/teacher/class`}
                        render={props => (<TeacherClazzPage {...props} key={props.location.search} />)}
                    />
                    <Route
                        path={`${window.config.appPath}/teacher/index`}
                        component={TeacherIndex}
                    />
                    <Route
                        path={`${window.config.appPath}/projects/:filter`}
                        component={ProjectsPage}
                    />
                    <Route
                        path={`${window.config.appPath}/project/:id`}
                        render={props => (<WrappedGui {...props} projectId={props.match.params.id} key={props.location.pathname} />)}
                    />
                    <Route
                        path={`${window.config.appPath}/user`}
                        render={props => (<UserProfilePage {...props} key={props.location.search} />)}
                    />
                    <Route
                        path={`${window.config.appPath}/mine`}
                        component={MinePage}
                    />
                    <Route
                        path={`${window.config.appPath}/settings`}
                        component={SetitingPage}
                    />
                    <Route
                        path={`${window.config.appPath}/promote`}
                        component={PromotePage}
                    />
                    <Route
                        path={`${window.config.appPath}/statistics`}
                        component={StatisticsPage}
                    />
                    <Route
                        path={`${window.config.appPath}/gui`}
                        component={WrappedGui}
                    />

                    <Route
                        path={`${window.config.appPath}/myclasses`}
                        component={MyClasses}
                    />

                    <Route
                        path={`${window.config.appPath}/class`}
                        render={props => (<MyClazzPage {...props} key={props.location.search} />)}
                    />

                    <Route
                        path={`${window.config.appPath}/mycourse`}
                        render={props => (<MyCoursePage {...props} key={props.location.search} />)}
                    />

                    <Route
                        path={`${window.config.appPath}/helper`}
                        component={HelperCenter}
                    />

                    <Route
                        path={`${window.config.appPath}/test`}
                        component={TestPage}
                    />

                    <Route
                        path={`${window.config.appPath}/competition`}
                        component={Competition}
                    />

                    <Route
                        path={`${window.config.appPath}/vip/sub`}
                        component={VipPage}
                    />

                </Switch>

            </Router>

            /*
                </IntlProvider>
            </Provider>

             */
        );
    }
}


const mapDispatchToProps = dispatch => ({
    setUser: user => dispatch(setUser(user)),
    closeLoginMenu: () => dispatch(closeLoginMenu())
});


const WrappedNavRouter = compose(
    AppStateHOC
)(connect(null, mapDispatchToProps)(NavRouter));

export default WrappedNavRouter;
